import styled from 'styled-components';

import { CampaignsEmptyState, NoResult } from 'ui/illustrations';
import { body2, colors, fontSizes, spacing } from 'ui/theme';
import { Link } from 'ui/links';

import { useEventHistoryFiltersContext } from '../contexts/EventHistoryFiltersContext';
import { ORDERED_TABLE_COLUMNS } from '../constants';

const KNOWLEDGE_CENTER_ARTICLE_URL =
  'https://support.iterable.com/hc/en-us/articles/218365803#event-history-tab';

const displayText = {
  noFilteredResults: 'No matching results',
  adjustFilters: 'Try adjusting your filters or searching by different keywords.',
  noUnfilteredResults: 'No events yet',
  learnMore: 'Learn more by visiting our ',
  knowledgeCenter: 'Knowledge Center',
};

const Wrapper = styled.div`
  grid-column: 1 / span ${ORDERED_TABLE_COLUMNS.length};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spacing.x10} 0;
`;

const Title = styled.div`
  margin: ${spacing.half} 0;
  font-size: ${fontSizes.s20};
  color: ${colors.textPrimary};
`;

const Description = styled.div`
  ${body2};
  color: ${colors.textSecondary};
`;

const NoFilteredResultsMessage = () => (
  <>
    <NoResult width={128} height={128} data-test="no-filtered-results-icon" />
    <Title>{displayText.noFilteredResults}</Title>
    <Description>{displayText.adjustFilters}</Description>
  </>
);

const NoUnfilteredResultsMessage = () => (
  <>
    <CampaignsEmptyState width={128} height={128} data-test="no-unfiltered-results-icon" />
    <Title>{displayText.noUnfilteredResults}</Title>
    <Description>
      {displayText.learnMore}{' '}
      <Link
        hasOpenNewTabIcon
        href={KNOWLEDGE_CENTER_ARTICLE_URL}
        rel="noopener noreferrer"
        target="_blank"
      >
        {displayText.knowledgeCenter}
      </Link>
      .
    </Description>
  </>
);

export const NoResultsPlaceholder = () => {
  const { search, eventFilters, userAgentFilters } = useEventHistoryFiltersContext();
  const isFiltered = !!search.length || !!userAgentFilters.length || !!eventFilters.length;
  return (
    <Wrapper data-test="no-results-placeholder">
      {isFiltered ? <NoFilteredResultsMessage /> : <NoUnfilteredResultsMessage />}
    </Wrapper>
  );
};
